import { render, staticRenderFns } from "./BaseStylableTextarea.vue?vue&type=template&id=a51f3950&scoped=true&lang=html"
import script from "./BaseStylableTextarea.vue?vue&type=script&lang=js"
export * from "./BaseStylableTextarea.vue?vue&type=script&lang=js"
import style0 from "./BaseStylableTextarea.vue?vue&type=style&index=0&id=a51f3950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51f3950",
  null
  
)

export default component.exports